import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const sellerPaymentsApi = createApi({
    reducerPath: "sellerPaymentsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getMySales: builder.query({
            query: () => ({
                url: "/Sale/my-sales",
                method: "GET",
            }),
        }),
        getMyTodaySales: builder.query({
            query: () => ({
                url: "/Sale/my-sales-today",
                method: "GET",
            }),
        }),
        getMyCarChanges: builder.query({
            query: () => ({
                url: "/Sale/my-car-changes",
                method: "GET",
            }),
        }),
        getMyRefundedSales: builder.query({
            query: () => ({
                url: "/Sale/my-refunded-sales",
                method: "GET",
            }),
        }),
    }),
});

export const { useGetMySalesQuery, useGetMyTodaySalesQuery, useGetMyCarChangesQuery, useGetMyRefundedSalesQuery } = sellerPaymentsApi;
